import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 12960 18616"
    {...props}
  >
    <path
      d="M10563 2965H4581l-718 4074c1190-636 2291-954 3300-954 804 0 1556 150 2261 451 700 305 1315 722 1839 1255 529 533 945 1165 1246 1891 301 730 451 1517 451 2355 0 1216-270 2320-816 3322-546 996-1332 1787-2359 2376-1023 588-2209 881-3554 881-1500 0-2720-275-3657-830-937-554-1599-1190-1990-1908-391-713-584-1340-584-1878 0-326 137-640 408-932 275-292 615-438 1027-438 705 0 1229 404 1573 1220 335 748 791 1328 1362 1745 572 417 1208 623 1913 623 644 0 1211-168 1697-503 490-335 864-799 1130-1388 262-584 395-1255 395-2002 0-804-141-1492-429-2063-284-572-666-997-1143-1281-477-279-1015-421-1599-421-722 0-1237 91-1551 267-310 176-757 481-1341 924-580 438-1061 661-1439 661-413 0-778-150-1096-447-318-300-477-635-477-1014 0-43 43-326 137-855l1057-6029c116-722 336-1246 654-1573C2600 163 3120 0 3842 0h6643c1307 0 1960 499 1960 1500 0 438-159 790-477 1061s-787 404-1405 404z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
